import React from 'react';
import styled from 'styled-components';

const IconWrapper = styled.button`
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 16px;
  top: 16px;
  z-index: 1001;
  transition: opacity 0.2s ease;
  color: white;

  &:hover {
    opacity: 0.7;
  }
`;

const MinimizeIcon = ({ onClick, className }) => (
  <IconWrapper onClick={onClick} title="Minimize" className={className}>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="9" width="16" height="2" rx="1" fill="currentColor" />
    </svg>
  </IconWrapper>
);

export default MinimizeIcon;



// WEBPACK FOOTER //
// ./src/components/icons/MinimizeIcon.js